import { Box, Flex, chakra } from "@chakra-ui/react";
import useNavItems, { isGroupItem } from "lib/hooks/useNavItems";

import Image from "next/image";
import { Link } from "toolkit/chakra/link";
import NavLink from "./NavLink";
import NavLinkGroup from "./NavLinkGroup";
import NavigationPromoBanner from "../promoBanner/NavigationPromoBanner";
import React from "react";
import RewardsButton from "ui/rewards/RewardsButton";
import UserProfileDesktop from "ui/snippets/user/profile/UserProfileDesktop";
import UserWalletDesktop from "ui/snippets/user/wallet/UserWalletDesktop";
import config from "configs/app";
import { useColorModeValue } from "toolkit/chakra/color-mode";
import { useIsTouchDevice } from "tools/utils/useTouch";

const NavigationDesktop = () => {
  const { mainNavItems } = useNavItems();
  const isTouch = useIsTouchDevice();
  const logoSrc = useColorModeValue(
    "/assets/logo-light.png",
    "/assets/logo-dark.png",
  );

  const [hoverIndex, setHoverIndex] = React.useState<number | null>(null);
  const [clickIndex, setClickIndex] = React.useState<number | null>(null);

  const isOpen = (index: number) => {
    if (isTouch) return clickIndex === index;
    return hoverIndex === index;
  };

  return (
    <Box
      className="desktop-navigation-shell"
      borderBottomWidth="1px"
      borderColor="border.divider"
      m="0 auto"
      maxWidth={1440}
    >
      <Flex
        display={{ base: "none", md: "flex" }}
        px={6}
        py={2}
        alignItems="center"
      >
        {/* LOGO */}
        <Link href="/" noIcon display="flex" alignItems="center">
          <Image src={logoSrc} width={210} height={42} alt="DotOneScan logo" />
        </Link>

        {/* NAV */}
        <chakra.nav ml="auto">
          <Flex as="ul" columnGap={3}>
            {mainNavItems.map((item, index) => {
              if (isGroupItem(item)) {
                return (
                  <NavLinkGroup
                    key={item.text}
                    item={item}
                    isTouch={isTouch}
                    isOpen={isOpen(index)}
                    // 💻 DESKTOP hover
                    onHoverOpen={() => {
                      if (!isTouch) setHoverIndex(index);
                    }}
                    onHoverClose={() => {
                      if (!isTouch) setHoverIndex(null);
                    }}
                    // 📱 MOBILE click
                    onClick={() => {
                      setClickIndex((prev) => (prev === index ? null : index));
                    }}
                  />
                );
              }

              return <NavLink key={item.text} item={item} noIcon />;
            })}
          </Flex>
        </chakra.nav>

        {/* RIGHT SIDE */}
        <Flex gap={2}>
          <NavigationPromoBanner />
          {config.features.rewards.isEnabled && <RewardsButton size="sm" />}
          {config.features.account.isEnabled && (
            <UserProfileDesktop buttonSize="sm" />
          )}
          {config.features.blockchainInteraction.isEnabled && (
            <UserWalletDesktop buttonSize="sm" />
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default React.memo(NavigationDesktop);
